// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.hidden {
  display: none;
}

.header-container {
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  height: 70px;
  color: #0669B3;
  margin-left: 34px;
  margin-right: 30px;
}
.header-container .header-left {
  display: flex;
  justify-content: space-between;
}
.header-container .header-left .header-name-container {
  display: flex;
  align-items: center;
  padding-top: 16px;
  margin-left: 35px;
  font-weight: 600;
}
.header-container .header-right {
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
}
.header-container .header-right .color-override {
  background: #0669B3 !important;
}
.header-container .header-right .nav-button-container {
  display: flex;
  align-items: center;
}
.header-container .header-right .nav-button-container .nav-button-links {
  border-radius: 4px;
  padding: 0 15px 0 15px;
  text-transform: lowercase;
}
.header-container .header-right span {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: 500;
}
.header-container .header-right span .nav-button-icon {
  padding-left: 10px;
}
.header-container .header-right .nav-button-text {
  color: white;
  font-size: 0.9em;
}

.mobile-hamburger {
  display: none;
}

@media only screen and (max-width: 900px) {
  .header-container {
    margin-left: 16px;
    margin-right: 0;
    display: flex;
    justify-content: space-between;
  }
  .mobile-hamburger {
    display: block;
    margin: 5px 25px 0 0;
  }
  .mobile-menu-links a {
    color: #19608f;
    font-size: 0.85em;
    font-weight: 500;
  }
  .nav-button-container {
    display: none !important;
  }
  .header-name-container h5 {
    margin: 0 2.5rem 0 0;
    font-size: 1em;
  }
  .mobile-menu-bold {
    font-weight: bold;
  }
  .helpful-links-dropdown div a {
    text-decoration: none;
  }
  Button a {
    color: #19608f;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Header.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,aAAA;AAKJ;;AAFA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,cDoBS;ECnBT,iBAAA;EACA,kBAAA;AAKJ;AAHI;EACI,aAAA;EACA,8BAAA;AAKR;AAHQ;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAKZ;AADI;EACI,aAAA;EACA,8BAAA;EACA,eAAA;AAGR;AADQ;EACI,8BAAA;AAGZ;AAAQ;EACI,aAAA;EACA,mBAAA;AAEZ;AAAY;EACI,kBAAA;EACA,sBAAA;EACA,yBAAA;AAEhB;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAAZ;AAEY;EACI,kBAAA;AAAhB;AAIQ;EACI,YAAA;EACA,gBAAA;AAFZ;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI;IACI,iBAAA;IACA,eAAA;IACA,aAAA;IACA,8BAAA;EAJN;EAOE;IACI,cAAA;IACA,oBAAA;EALN;EAQE;IACI,cDhFE;ICiFF,iBAAA;IACA,gBAAA;EANN;EASE;IACI,wBAAA;EAPN;EAUE;IACI,oBAAA;IACA,cAAA;EARN;EAWE;IACI,iBAAA;EATN;EAYE;IACI,qBAAA;EAVN;EAaE;IACI,cDvGE;EC4FR;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
